export default "__VITE_ASSET__CyM5LoY9__"